module.exports = __webpack_public_path__ + "images/img-vfSn_sp.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/reviews-on-offerhubs-ru.png
// module id = 2057
// module chunks = 0